// MessageCategory.js
import { connect } from 'react-redux';

import MessageCategory from '../component/MessageCategory.jsx';

import getMessageData from '../selector/getMessageData.js';

const mapStateToProps = (state, { messageId = '' }) => {
  return {
    categories: getMessageData(state, messageId, 'categories'),
  };
};

export default connect(mapStateToProps)(MessageCategory);
